<template>
    <div>
        <common-table :url="url"
                      :table-columns="tableColumns"
                      :form-fields="formFields"
                      :operate="[]"
                      :permission="permission"
                      :searchs="searchs"
                      ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "AgentDomain",
        components: {CommonTable},
        data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'domain',
                    placeholder: '域名',
                    type: 'input'
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                permission:{
                    add: 'agentDomain:add',
                    update: 'agentDomain:update',
                    delete: 'agentDomain:delete',
                    deleteBatch: 'agentDomain:deleteBatch'
                },
                url: {
                    get: '/agentDomain/listByCondition',
                    add: '/agentDomain/add',
                    update: '/agentDomain/update',
                    delete: '/agentDomain/delete/',
                    delete_batch: '/agentDomain/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    width: '',
                }, {
                    field: 'domain',
                    label: '域名',
                    show: true,
                    width: ''
                },{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '180px',
                }],
                formFields: {
                    addTitle: '添加域名',
                    updateTitle: '修改域名',
                    labelWidth: '80px',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        placeholder: '请选择代理',
                        rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                        selectUrl: '/agent/top',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'domain',
                        label: '域名',
                        type: 'input',
                        placeholder: '域名',
                        rules: [{
                            message: '请输入域名', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
